import { Meta } from '@/src/components/common/Meta';
import { i18nKeys } from '@/src/utils/i18n.utils';
import React from 'react';
import { useTranslation } from 'react-i18next';
import JoinAnEvent from '../components/game/JoinAnEvent';

export const JoinAnEventPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t(i18nKeys.meta.joinAnEvent.title)} />
      <JoinAnEvent />
    </>
  );
};
